export class ConfigModel {

    public webServiceURL: string;
    public defaultCategory: string = 'R';
    public defaultFilters = {
        showSales: true,
        showRentals: true,
        showSuspended: true,
        showHistoricized: false
    }
    public lastVersionInfo: string = '';
}


// WEBPACK FOOTER //
// ./src/models/config.model.ts